import { useState, useEffect, useCallback } from "react";

const useContactFormValidation = (formData, requiredFields) => {
    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [touched, setTouched] = useState({}); // Tracks fields the user has interacted with

    // Memoized validation logic
    const validateForm = useCallback(() => {
        const newErrors = {};
        requiredFields.forEach((field) => {
            if (!formData[field]?.trim()) {
                newErrors[field] = "This field is required.";
            }
        });
        if (
            formData.email &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Please enter a valid email address.";
        }
        return newErrors;
    }, [formData, requiredFields]);

    useEffect(() => {
        // Avoid unnecessary re-renders if validation results haven't changed
        const newErrors = validateForm();
        setErrors((prevErrors) => {
            const areErrorsEqual =
                Object.keys(prevErrors).length === Object.keys(newErrors).length &&
                Object.keys(prevErrors).every((key) => prevErrors[key] === newErrors[key]);

            if (!areErrorsEqual) {
                return newErrors;
            }
            return prevErrors; // No update if errors haven't changed
        });
        setIsFormValid(Object.keys(newErrors).length === 0);
    }, [validateForm]);

    // Handle marking fields as touched
    const markFieldTouched = (field) => {
        setTouched((prevTouched) => ({ ...prevTouched, [field]: true }));
    };

    return { errors, touched, isFormValid, markFieldTouched };
};

export default useContactFormValidation;
